export default __webpack_public_path__ + "static/media/equine.2640df38.svg";